// extracted by mini-css-extract-plugin
export default {"autoComplete":"z2-z","error":"A2-z","disabled":"B2-z"};